import {Sprite} from 'pixi.js';
import {ObjectBuilder, Button, Text} from '@gongxigames/framework/core';
import {MenuBarViewMobileLandscape} from '@gongxigames/framework/slot/modules/menubar/MenuBarViewMobileLandscape';
import {KeypadView, KeypadViewMobilePortrait} from '@gongxigames/framework/slot/modules/keypad';

export class MenuBarViewMobilePortrait extends MenuBarViewMobileLandscape {
    public static readonly NAME: symbol = Symbol('MenuBarViewMobilePortrait');

    protected initMainSprite(): void {
        this._menuBar = this._objectBuilder.buildSprite(ObjectBuilder.resources.shared_sprite.menuBar_portrait);
    }

    protected initGraphicElements(): void {
        this._menuButton = this.mainSprite.getChildByName<Button>('menuButton');
        this._label = this._menuBar.getChildByName<Text>('label');
    }

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobilePortrait.NAME).mainSprite;
    }

    protected updateButtonPanelPosition(): void {
        const width = this._gameConfig.viewport.mobile.height;

        this._buttonPanelPosition = {
            width,
            x: 0,
            y: 140
        };
    }

    public getViewDependencies(): (symbol|string)[] {
        return [KeypadViewMobilePortrait.NAME];
    }
}
